module.exports = __webpack_public_path__ + "static/media/15Demo Photo-ink-min.ffdf3640.jpeg";